export const ROUTES = {
  AUTH: {
    LOGIN: "/auth/login",
    AUTHENTICATE: "/auth/authenticate",
  },
  PUBLIC: {
    ONBOARD: "/registro",
  },
  DASHBOARD: {
    BASE: "/dashboard",
    HOME: "/dashboard/resumen",
    CUSTOMERS: "/dashboard/clientes",
    INVOICES: "/dashboard/recaudos",
    SETTLEMENTS: "/dashboard/conciliacion",
    SETTLEMENT_DETAIL: "/dashboard/conciliacion/:settlementId",
    WHATSAPP: "/dashboard/whatsapp",
    PAYOUTS: "/dashboard/pagos",
    PAYOUTS_BATCH: "/dashboard/pagos/lote/:batchId",
    SUBSCRIPTIONS: "/dashboard/suscripciones",
    BILLING: "/dashboard/facturacion",
    MERCHANTS: "/dashboard/comercios",
    MERCHANT_REQUEST: "/dashboard/comercios/solicitud",
    MERCHANT_REQUEST_DETAIL: "/dashboard/comercios/solicitud/:id",
    TUTORIALS: "/dashboard/tutoriales",
    WELCOME: "/dashboard/bienvenida",
    PROTECT: "/dashboard/protect",
    PROTECT_INDUCTION: "/dashboard/protect/induccion",
    LOGOUT: "/dashboard/logout",
  },
} as const;
